import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CustomerVehiclePage } from './customer-vehicle';

@NgModule({
  declarations: [
    CustomerVehiclePage,
  ],
  imports: [
    IonicPageModule.forChild(CustomerVehiclePage),
  ],
})
export class CustomerVehiclePageModule {}



// WEBPACK FOOTER //
// ./src/pages/customer-vehicle/customer-vehicle.module.ts